import Page from "../../components/Page";
import useAssessmentReview from "./hooks/useAssessmentReview";

const AssessmentReview = () => {
  const page = useAssessmentReview();
  return <Page {...page} />;
};

export default AssessmentReview;
